import { motion } from 'framer-motion'
import { useInView } from 'react-intersection-observer'
import { useTranslation } from 'react-i18next'

const companies = [
  { name: 'RETAIL', highlight: 'CORP', style: 'italic' },
  { name: 'SMART', highlight: 'BANK', style: '' },
  { name: 'HOSPITALITY+', highlight: '', style: 'tracking-tighter' },
  { name: 'TechCenter', highlight: '', style: 'uppercase' },
  { name: 'LUXE', highlight: 'HOTELS', style: 'font-serif' },
]

export default function TrustedBy() {
  const { t } = useTranslation()
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 })

  return (
    <div className="py-12 bg-white dark:bg-slate-900 border-y border-slate-100 dark:border-slate-800">
      <div className="max-w-7xl mx-auto px-4 text-center">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          className="text-sm font-semibold text-slate-400 uppercase tracking-widest mb-8"
        >
          {t('trusted.title')}
        </motion.p>
        <div ref={ref} className="flex flex-wrap justify-center gap-6 sm:gap-12 opacity-50 grayscale hover:grayscale-0 transition-all">
          {companies.map((company, index) => (
            <motion.div
              key={company.name}
              initial={{ opacity: 0, y: 20 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ delay: index * 0.1 }}
              className={`flex items-center gap-2 text-lg sm:text-2xl font-bold ${company.style}`}
            >
              {company.name}
              {company.highlight && (
                <span className={company.name === 'RETAIL' ? 'text-primary' : 'text-accent'}>
                  {company.highlight}
                </span>
              )}
              {company.name === 'LUXE' && <span className="font-light">{company.highlight}</span>}
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  )
}
